import { render, staticRenderFns } from "./UploadFileAdmin.vue?vue&type=template&id=4c01eca0&scoped=true"
import script from "./UploadFileAdmin.vue?vue&type=script&lang=js"
export * from "./UploadFileAdmin.vue?vue&type=script&lang=js"
import style0 from "./UploadFileAdmin.vue?vue&type=style&index=0&id=4c01eca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c01eca0",
  null
  
)

export default component.exports